// Elevair Brand Constants
export const BRAND = {
    name: 'Elevair',
    tagline: 'Elevate Your Business',
    description: 'The all-in-one platform for virtual assistants and brand coaches',
    website: 'https://elevair.io',
    supportEmail: 'support@elevair.io',
    socialMedia: {
        twitter: '@elevairhq',
        linkedin: 'company/elevair',
        instagram: '@elevairhq',
    },
};
export const COLORS = {
    // Primary palette
    primary: '#E07A5F', // Coral - warm, action-oriented
    secondary: '#1D3557', // Navy - trustworthy, professional
    accent: '#2A9D8F', // Teal - CTAs, buttons
    // Neutrals
    background: '#FDF8F3', // Warm white - light backgrounds
    text: '#2D3436', // Charcoal - body text
    white: '#FFFFFF',
    // Emotional zones
    zones: {
        marketing: {
            primary: '#E07A5F',
            background: '#FDF8F3',
        },
        dashboard: {
            primary: '#5C6B73',
            background: '#F9FAFB',
        },
        invoicing: {
            primary: '#D4A574',
            accent: '#38A169', // Green for money
            background: '#FFFBF5',
        },
        calendar: {
            primary: '#4A90A4',
            background: '#F8FAFC',
        },
        messaging: {
            primary: '#E8998D',
            background: '#FFF9F7',
        },
        analytics: {
            primary: '#6366F1',
            background: '#F8FAFC',
        },
    },
    // Status colors
    status: {
        success: '#38A169',
        warning: '#D69E2E',
        error: '#E53E3E',
        info: '#3182CE',
    },
    // Tier colors
    tiers: {
        free: '#6B7280',
        trial: '#3B82F6',
        launch: '#10B981',
        rise: '#8B5CF6',
        summit: '#F59E0B',
        expired: '#9CA3AF',
    },
};
export const TYPOGRAPHY = {
    // Font families
    fontFamily: {
        logo: 'Georgia, serif',
        heading: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
        body: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
        mono: "'JetBrains Mono', 'Fira Code', monospace",
    },
    // Font sizes (in rem)
    fontSize: {
        xs: '0.75rem',
        sm: '0.875rem',
        base: '1rem',
        lg: '1.125rem',
        xl: '1.25rem',
        '2xl': '1.5rem',
        '3xl': '1.875rem',
        '4xl': '2.25rem',
        '5xl': '3rem',
    },
};
export const SPACING = {
    // Base unit: 8px
    unit: 8,
    xs: 4,
    sm: 8,
    md: 16,
    lg: 24,
    xl: 32,
    '2xl': 48,
    '3xl': 64,
};
export const BORDERS = {
    radius: {
        sm: '4px',
        md: '8px',
        lg: '12px',
        xl: '16px',
        full: '9999px',
    },
};
//# sourceMappingURL=brand.js.map